import { render } from "./FeaturedBusinessList.vue?vue&type=template&id=5f151845&scoped=true"
import script from "./FeaturedBusinessList.vue?vue&type=script&lang=js"
export * from "./FeaturedBusinessList.vue?vue&type=script&lang=js"

import "./FeaturedBusinessList.vue?vue&type=style&index=0&id=5f151845&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f151845"]])

export default __exports__